import React, {Component} from 'react';
import NavPointMenu from '../new-ui/nav_point_menu';
import {Link} from 'react-router-dom';
import {injectIntl} from 'react-intl';
class TrialEndHeader extends Component {
	render() {
		const {formatMessage} = this.props.intl;
		return (
			<div className="trial-end-header">
				{this.props.showLogout ? (
					<div className="log-out-btn" role="menuitem" tabIndex="-1" onClick={this.props.onLogoutClick}>
						{formatMessage({id: 'header.log-out'})}
						<div className={'log-out-icon'} />
					</div>
				) : (
					<div className={'header-btns'}>
						<Link to="/" className="logo" role="button">
							<span className="visually-hidden">My Work</span>
						</Link>
					</div>
				)}

				{this.props.showNav ? (
					<div className="trial-end-header-bar">
						<NavPointMenu options={this.props.availableHeaders} activeOption={this.props.page} />
					</div>
				) : null}
			</div>
		);
	}
}

export default injectIntl(TrialEndHeader);
